module.exports = __webpack_public_path__ + "img/ts21.e6b9671c.png";